import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import MuiRaisedButton from 'material-ui/RaisedButton';
import MuiPaper from 'material-ui/Paper';
import PropTypes from 'prop-types';
import { makeMonthlyPayment } from '../../../store/ducks/payment';
import Icon, { NAMES } from '@ifit/react-icons';
import { shark } from '../../../theme/colors';
import styles from '../../../shared-styles';
import './wolf-plan-options.css';
import getPrice from './wolf-pricing';

const labelStyle = {
  ...styles.buttonLabelStyle,
  lineHeight: '48px'
};

class WolfPlanOptions extends Component {
  makePayment = async () => {
    try {
      await this.props.makeMonthlyPayment(this.props.hasFreeTrial);
    } catch (err) {
      // silently fail
    }
  }

  render() {
    const { hasFreeTrial, onBack, currencyCode, mediaType } = this.props;
    const digitalVendor = (/Android/i.test(navigator.userAgent)) ? 'Google Play' : 'App Store';

    return (
      <div className="wolf-plan-component">
        <Icon
          className={ classnames('back-arrow-icon', mediaType) }
          name={ NAMES.ARROW_LEFT }
          color={ shark }
          size={ 24 }
          unitSize="px"
          onClick={ onBack }
        />
        <div className={ classnames('plan-container', mediaType) }>
          <MuiPaper zDepth={ 1 } className="plan-options-container">
            <div className="plan-header">
              <div>
                <h1 className={ hasFreeTrial ? 'free-trial' : 'no-free-trial' }>
                  {getPrice(currencyCode)}/month
                </h1>
              </div>
            </div>
            <div className="plan-details">
              <h3>Join iFit to access:</h3>
              <ul>
                <li><span>Thousands of new, trainer-led workouts</span></li>
                <li><span>Daily Global Workout destinations</span></li>
                <li><span>Premium content tailored to your goals</span></li>
                <li><span>More machine types, like treadmills, bikes, rowers, ellipticals, and strength</span></li>
              </ul>
            </div>

            <div className="term-details">
              <h4>Subscription Pricing & Terms</h4>
              <p>The total amount for your iFit Individual Monthly membership ({ getPrice(currencyCode) }) will be charged to your {digitalVendor} account at the end of your 30-day free trial. Cancellation is required 24 hours before your trial ends. Manage your subscription in Account Settings at any time.</p>
            </div>
          </MuiPaper>
          <MuiRaisedButton
            className="plan-option-yearly"
            label={ `Subscribe for ${getPrice(currencyCode)}/month` }
            style={ styles.buttonStyle }
            labelStyle={ labelStyle }
            primary={ true }
            onClick={ this.makePayment }
          />
          <p>1-month FREE TRIAL, then pay just {getPrice(currencyCode)}/month!</p>
        </div>
      </div>
    );
  }
}

WolfPlanOptions.propTypes = {
  currencyCode: PropTypes.string,
  hasFreeTrial: PropTypes.bool,
  makeMonthlyPayment: PropTypes.func.isRequired,
  mediaType: PropTypes.string,
  onBack: PropTypes.func.isRequired
};

export default connect(
  state => ({
    currencyCode: state.payment.currencyCode,
    hasFreeTrial: state.payment.hasFreeTrial,
    mediaType: state.config.mediaType,
  }),
  dispatch => ({
    makeMonthlyPayment: async (hasFreeTrial) => {
      dispatch(makeMonthlyPayment(hasFreeTrial));
    }
  })
)(WolfPlanOptions);
